var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('order-body',{attrs:{"isOk":true,"isPage":true,"codeStatus":200,"pageText":'orderConfirm'},on:{"print":_vm.print}})}
var staticRenderFns = []

export { render, staticRenderFns }